import { Typography } from "@mui/material"

type Props = {}

const NotificationsTitle = (props: Props) => {
  return <Typography variant="h5">Notifications</Typography>
}

export default NotificationsTitle
